<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/components/Tabs';

.AuthRegisterPage {
    .Tabs(@brand-primary);

    .Tabs {
        display: flex;
    }

    .Tabs li {
        flex: 1;

        a {
            text-align: center;
            font-style: italic;
            font-size: 18px !important;
            color: #989898;
        }

        a:hover,
        &.active > a,
        &.active > a:active,
        &.active > a:focus,
        &.active > a:hover {
            color: black;
        }
    }

    .btn {
        // width: 100%;
    }

    .control-label {
        display: none;
    }

    input.form-control {
        height: 58px;
        line-height: 58px;
        padding: 0 10px;
    }

    .password-field-wrapper {
        position: relative;

        input.form-control {
            padding-right: 45px;
        }

        .password-toggle-btn {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 45px;
            background: none;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-size: 16px;
            outline: none;

            &:hover {
                color: #333;
            }
        }
    }
}
</style>

<script type="text/babel">
import RangeSlider from 'dashboard-js/components/utilities/RangeSlider'

export default {
    mixins: [],
    components: {
        RangeSlider,
    },
    props: [],

    data() {
        return {
            showPassword: false,
            showPasswordConfirmation: false,
            form: new SparkForm({
                brand_name: '',
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                terms: null,
            }),
        }
    },

    mounted() {},

    methods: {
        registerBrand() {
            this.register('brand')
        },

        registerInfluencer() {
            this.register('influencer')
        },

        register(type) {
            Spark.post('/register/' + type, this.form).then(response => {
                Spark.redirect(response.redirect)
            })
        },
    },
}
</script>
